import { useTranslation } from "react-i18next";
import type { ReplyContext } from "@/hooks/useWhatsAppChat";

function getReplyIcon(type?: string): string {
  switch (type) {
    case "image": return "ri-image-line";
    case "video": return "ri-video-line";
    case "audio": return "ri-music-line";
    case "ptt": return "ri-mic-line";
    case "document": return "ri-file-3-line";
    case "location": return "ri-map-pin-line";
    case "sticker": return "ri-sticky-note-line";
    case "contact":
    case "vcard": return "ri-user-line";
    case "link": return "ri-link";
    case "gp2_revoke":
    case "revoked": return "ri-delete-bin-line";
    default: return "ri-chat-1-line";
  }
}

interface ReplyPreviewProps {
  reply: ReplyContext;
  onCancel: () => void;
}

export default function ReplyPreview({ reply, onCancel }: ReplyPreviewProps) {
  const { t } = useTranslation("dashboard");

  return (
    <div className="flex items-center gap-2 px-3 py-2 bg-background-100/60 border-t border-background-200/60 animate-in slide-in-from-bottom-2 duration-150">
      <div className="flex-1 min-w-0 border-l-[3px] border-secondary-400 pl-3 py-1">
        <span className="text-[11px] text-secondary-600 font-medium block">
          {reply.senderName || t("reply.replyTo")}
        </span>
        <p className="text-xs text-foreground-500 truncate mt-0.5 flex items-center gap-1">
          <i className={`${getReplyIcon(reply.type)} text-[11px] text-foreground-400 flex-shrink-0`}></i>
          <span className="truncate">
            {reply.body.length > 80 ? reply.body.slice(0, 80) + "..." : reply.body}
          </span>
        </p>
      </div>
      <button
        onClick={onCancel}
        className="w-7 h-7 flex items-center justify-center rounded-full hover:bg-background-200 text-foreground-400 cursor-pointer transition-colors flex-shrink-0"
      >
        <i className="ri-close-line text-sm"></i>
      </button>
    </div>
  );
}